import axios from 'axios';
import keycloakAuth from '@/services/keycloakAuth';
// import router from '@/router';
// import Swal from 'sweetalert2';
import store from '@/state';
import { handleAccountAccessDenial } from '../../../shared/accountAccess';
import {
  isAppOrSiteRequest,
  publishBootstrap,
  settleUnauthorized,
} from '../../../shared/bootstrap-failure.mjs';

/*
axios.interceptors.request.use(config => {
    config.baseURL = window.config.apiUrl;
    return config;
});
*/

// Request interceptor
axios.interceptors.request.use(request => {
  // Get token from Keycloak
  const token = keycloakAuth.getToken();

  if (token) {
    request.headers.common.Authorization = `Bearer ${token}`;
  }

  /*
    const locale = store.getters['lang/locale']
    if (locale)
    {
        request.headers.common['Accept-Language'] = locale
    }
    */
  // request.headers['X-Socket-Id'] = Echo.socketId()
  return request;
});

// Response interceptor
axios.interceptors.response.use(
  response => {
    if (isAppOrSiteRequest(response && response.config && response.config.url)) {
      publishBootstrap({ appSiteRequestError: null });
    }
    return response;
  },
  error => {
    if (handleAccountAccessDenial(error)) {
      return Promise.reject(error);
    }

    const status = error.response ? error.response.status : 0;

    if (status >= 500) {
      /*
        Swal.fire({
          type: 'error',
          title: 'Error',
          text:
            'Unknown Backend Error Occured. Please refresh and try again and if error persists, please contact support',
          reverseButtons: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        });
      */
    }

    return Promise.resolve(settleUnauthorized(error, {
      isAuthenticated: () => keycloakAuth.isAuthenticated(),
      refresh: () => keycloakAuth.refreshToken({ redirectOnFail: false }),
      logout: () => keycloakAuth.logout(),
      clearSession: () => store.commit('logout'),
      redirectToLogin: () => {
        const base = window.config && window.config.grooveappsurl ? window.config.grooveappsurl : '';
        window.location.replace(`${base}/#/login`);
      },
      recordLoginFailure: (failure) => {
        keycloakAuth.loginFailure = failure;
        publishBootstrap({ loginFailure: failure });
      },
      recordAppSiteFailure: (failure) => {
        publishBootstrap({ appSiteRequestError: failure });
      },
    })).then(() => Promise.reject(error));
  }
);
